import htmlToElement from 'html-to-element';

export default class Overlay {
  constructor(targetContainer, backgroundColor = '#fff', duration = 1000) {
    this.backgroundColor = backgroundColor;
    this.duration = duration;
    this.targetContainer = targetContainer;
    this.prepare();
  }

  prepare() {
    const html = `<div class="layer layer--overlay" style="background-color:${this.backgroundColor}; transition-duration:${this.duration}ms"></div>`;
    this.elem = htmlToElement(html);
    this.targetContainer.appendChild(this.elem);
  }

  destroy() {
    this.targetContainer.removeChild(this.elem);
  }

  async show() {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.elem.classList.add('layer--current');
      }, 0);
      setTimeout(() => {
        resolve();
      }, this.duration);
    });
  }

  async hide() {
    return new Promise((resolve) => {
      this.elem.classList.remove('layer--current');
      setTimeout(() => {
        resolve();
        this.destroy();
      }, this.duration);
    });
  }
}
